import React, { useState } from "react";
import {
  useTable,
  useGlobalFilter,
  useSortBy,
  usePagination,
} from "react-table";
import ReactPaginate from "react-paginate";
import DownArrowDark from "../../../images/DownArrowDark.svg";
import UpArrowDark from "../../../images/UpArrowDark.svg";
import search from "../../../images/search.svg";

const TransactionTable = (props) => {
  const { data, pageCount, columns } = props;

  const [activePage, setActivePage] = useState(0);
  const [refresh, setRefresh] = useState(false);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    state,
    page,
    setPageSize,
    pageOptions,
    gotoPage,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        pageSize: 10,
        pageIndex: 0,
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const { pageIndex, pageSize } = state;

  return (
    <>
      <div className="search-box">
        <input
          className="form-control"
          type="search"
          name="search"
          placeholder="Search..."
          onChange={(e) => {
            props.getTransData({
              variables: {
                search_text: `%${e.target.value}%`,
                order_by: { created_at: "desc" },
                business_profile_id: localStorage.getItem("profile_id"),
              },
            });
          }}
        />
        <button className="search-btn">
          <img src={search} alt="search" />
        </button>
      </div>

      <table className="table" {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  onClick={() => {
                    let order_by = {};

                    if (column.isDesc === undefined) {
                      column.isDesc = false;
                      column.isAsc = true;
                    } else {
                      if (column.isDesc) {
                        column.isDesc = false;
                        column.isAsc = true;
                      } else {
                        column.isDesc = true;
                        column.isAsc = false;
                      }
                    }

                    if (column.id !== "type") {
                      order_by[column.id] = column.isDesc ? "desc" : "asc";

                      props.getTransData({
                        variables: {
                          search_text: `%%`,
                          order_by: order_by,
                          business_profile_id:
                            localStorage.getItem("profile_id"),
                        },
                      });
                    }
                    setRefresh(!refresh);
                  }}
                  style={{ cursor: "pointer" }}
                  {...column.getHeaderProps([{ className: column.className }])}
                >
                  {column.render("Header")}
                  <span>
                    {column.isAsc ? (
                      <img
                        style={{
                          height: "12px",
                          margin: "0px 4px",
                          width: "12px",
                        }}
                        src={UpArrowDark}
                        alt="up"
                      />
                    ) : (
                      <img
                        style={{
                          height: "12px",
                          margin: "0px 4px",
                          width: "12px",
                        }}
                        src={DownArrowDark}
                        alt="down"
                      />
                    )}
                  </span>
                  <div>{column.canFilter ? column.render("Filter") : null}</div>
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {page?.length > 0
            ? page.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      return (
                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                      );
                    })}
                  </tr>
                );
              })
            : ""}
        </tbody>
      </table>
      {!props.transLoading ? (
        props.transError ? (
          "some error occurred..."
        ) : page?.length > 0 ? (
          <div className="page-footer">
            <div>
              <select
                value={pageSize}
                onChange={(e) => setPageSize(Number(e.target.value))}
                onClick={() => {
                  setActivePage(pageIndex);
                }}
              >
                {[10, 20, 30].map((pageSize) => (
                  <option key={pageSize} value={pageSize}>
                    {pageSize}
                  </option>
                ))}
              </select>
              <span className="footer-page-value">
                Showing {pageIndex * pageSize + 1} -{" "}
                {pageIndex * pageSize + pageSize > pageCount
                  ? pageCount
                  : pageIndex * pageSize + pageSize}{" "}
                of {pageCount}
              </span>
            </div>
            <div className="buttons-pos">
              <button
                className="double-button left"
                onClick={() => {
                  setActivePage(0);
                  gotoPage(0);
                }}
              >
                {"<<"}
              </button>{" "}
              <ReactPaginate
                containerClassName={"pagination"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
                className={"pagination"}
                previousLinkClassName={"prev-link-class"}
                nextLinkClassName={"prev-link-class"}
                previousLabel={"<"}
                pageRangeDisplayed={3}
                forcePage={activePage}
                onPageChange={(e) => {
                  gotoPage(e.selected);
                }}
                nextLabel={">"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={Math.ceil(pageCount / pageSize)}
                marginPagesDisplayed={2}
              />
              <button
                className="double-button right"
                onClick={() => {
                  setActivePage(pageOptions.length - 1);
                  gotoPage(pageOptions.length - 1);
                }}
              >
                {">>"}
              </button>{" "}
            </div>
          </div>
        ) : (
          "No Data Found..."
        )
      ) : (
        "Loading..."
      )}
    </>
  );
};
export default TransactionTable;
